export default "__VITE_ASSET__Bc036j_W__"